import React, {useState} from 'react';
import {Link, withRouter} from 'react-router';
import {Button, Icon, MenuListItem, SplitButton, WindowSizeConsumer} from '@albert-io/atomic';
import {history} from 'client/history';
import NewFolderModal from 'components/PracticeView/FoldersModal/NewFolderModal/NewFolderModal.react';

import './assignments-folders-wrapper.scss';

type AssignmentsFoldersWrapperProps = {
  children: React.ReactNode;
  router: any;
};

const AssignmentsFoldersWrapper = ({children, router}: AssignmentsFoldersWrapperProps) => {
  const [isFoldersModalOpen, setIsFoldersModalOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <WindowSizeConsumer>
      {({breakpoints, viewportWidth}) => {
        const isMobile = viewportWidth <= breakpoints.m;
        if (isMobile) {
          return <>{children}</>;
        }
        return (
          <div className='flex'>
            <div className='u-pad-tb_4 u-pad-lr_3 assignments-folders-sidebar flex flex-col'>
              <div>
                <SplitButton>
                  <Button
                    onClick={() => history.pushState(null, '/assignment-builder/create-assignment')}
                    data-testid='assignments_new-assignment-btn'
                  >
                    <Icon icon='plus' className='u-mar-r_1' />
                    New Assignment
                  </Button>
                  <Button
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    data-testid='assignments_dropdown-btn'
                  >
                    <Icon icon='caret-down' />
                  </Button>
                </SplitButton>
                {isDropdownOpen && (
                  <div className='assignments-folders-sidebar__new-folder'>
                    <MenuListItem
                      onClick={() => setIsFoldersModalOpen(true)}
                      data-testid='assignments_new-folder-btn'
                    >
                      <Icon icon='plus' className='u-mar-r_1' />
                      New Folder
                    </MenuListItem>
                  </div>
                )}
              </div>
              <MenuListItem
                as={Link}
                to='/assignments'
                className='assignments-folders-sidebar__item u-mar-t_3'
                selected={router.location.pathname?.startsWith('/assignments')}
                disableWhenSelected={false}
              >
                <Icon icon={['fal', 'file-alt']} className='nav-submenu_assignments-icon' />
                Assignments
              </MenuListItem>
              <MenuListItem
                as={Link}
                to='/saved'
                className='assignments-folders-sidebar__item'
                selected={router.location.pathname?.startsWith('/saved')}
                disableWhenSelected={false}
              >
                <Icon icon={['far', 'folder-open']} className='u-mar-r_1' />
                Folders
              </MenuListItem>
            </div>
            <div style={{flex: 1}}>{children}</div>
            {isFoldersModalOpen && (
              <NewFolderModal handleClose={() => setIsFoldersModalOpen(false)} />
            )}
          </div>
        );
      }}
    </WindowSizeConsumer>
  );
};

export default withRouter(AssignmentsFoldersWrapper);
